import React from 'react';
import { LinkDrillDown } from "../../../../../../shared/components/CustomCells/LinkDrillDown";
import { ColumnsFactory } from "../../../../../../shared/components/Grid/functions";

export const getColumnDefs = () => {

  const LinkCell = (params) =>{
    return <LinkDrillDown params={params} onClickDrillDown={()=>{}} dataOption='' drillAll/>
  }

  return [
    ColumnsFactory.TextColumn("Nombre", "nombre"),
    ColumnsFactory.TextColumn("Email", "email"),
    ColumnsFactory.TextColumn("Cod. Sg/Dn", "idDN"),
    ColumnsFactory.TextColumn("Sg/Dn","direccionNegocio"),
    ColumnsFactory.NumericColumn("Sin Adjuntos", "partesSinAdjuntos", {ipkTotalizar: true, cellRendererFramework:LinkCell})
  ];
};